import { Formik } from 'formik';
import { Link } from 'react-router-dom';

import AuthForm from './AuthForm';
import AuthInput from './AuthInput';
import AuthOr from './AuthOr';
import AuthSub from './AuthSub';
import AuthSubmit from './AuthSubmit';
import { confirmPasswordSchema } from './schemas/confirm-password.schema';

import { AuthRoutes } from '@/interfaces/auth/AuthRoutes.enum';

type PropTypes = {
	handleSubmit: (
		username: string,
		newPassword: string,
		code: string,
	) => Promise<void>;
	loading: boolean;
};
export default function ConfirmPasswordForm({
	handleSubmit,
	loading,
}: PropTypes) {
	const initialValues = {
		username: '',
		code: '',
		password: '',
	};

	return (
		<Formik
			initialValues={initialValues}
			validationSchema={confirmPasswordSchema}
			onSubmit={({ username, password, code }) =>
				handleSubmit(username, password, code.toString())
			}
		>
			{({ errors, touched }) => (
				<AuthForm>
					<AuthInput
						name="username"
						label="Username"
						type="email"
						placeholder="user@example.com"
						error={!!errors.username}
						touched={touched.username}
						data-test="confirm-password-username"
					/>
					<AuthInput
						name="password"
						label="New Password"
						type="password"
						enableCustomValidations={true}
						placeholder="********"
						error={!!errors.password}
						touched={touched.password}
						data-test="confirm-password-password"
					/>
					<AuthInput
						name="code"
						label="Code"
						type="tel"
						placeholder="123456"
						error={!!errors.code}
						touched={touched.code}
						data-test="confirm-password-code"
					/>
					<AuthSubmit
						isLoading={loading}
						data-test="confirm-password-submit"
						className="bg-purpleBrand-500 hover:bg-purpleBrand-600 active:bg-purpleBrand-900"
					/>
					<AuthOr />
					<AuthSub>
						<p>
							Don't have a code?{' '}
							<Link
								className="font-medium text-purpleBrand-500"
								to={AuthRoutes.ForgotPassword}
								data-test="link-forgot-password"
							>
								Click here
							</Link>
						</p>
						<p>
							Already confirmed?{' '}
							<Link
								className="font-medium text-purpleBrand-500"
								to={AuthRoutes.SignIn}
								data-test="link-sign-in"
							>
								Sign in
							</Link>
						</p>
						<p>
							Don't have an account?{' '}
							<Link
								className="font-medium text-purpleBrand-500"
								to={AuthRoutes.SignUp}
								data-test="link-sign-up"
							>
								Sign up
							</Link>
						</p>
					</AuthSub>
				</AuthForm>
			)}
		</Formik>
	);
}
